// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_xlsx_dist_xlsx_mini_min_js":"5f73d781f0f91c31","node_modules_xlsx_xlsx_mjs":"8f4b5b3467de1eff","node_modules_azure_msal-browser_dist_controllers_NestedAppAuthController_mjs":"ec1b80f5321a461c"}[chunkId] + ".js";
};